import React, {useState, useEffect} from 'react';
import Header from '../header/Header';
import '../statusCheck/StatusCheck.css';
import red_line from '../../img/red_line.png';
import { useDispatch,useSelector } from 'react-redux';
//import { setNumber,setPassword } from '../../features/searchComplaint/SearchComplaintSlice';
import { searchComplaint, changeComplaintType } from '../../features/searchComplaint/SearchComplaintSlice';
import { useNavigate } from 'react-router-dom'; 

const StatusCheck = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [number, setNumber] = useState('');
    const [password, setPassword] = useState('');
    const [currentPage, setCurrentPage] = useState(window.location.pathname);

    useEffect(() => {
      function handlePageChange() {
          setCurrentPage(window.location.pathname);
      }
      window.addEventListener("popstate", handlePageChange);
      return () => {
          window.removeEventListener("popstate", handlePageChange);
      };
  }, [currentPage]);
    // const selector = useSelector(state => state.searchComplaint);
    const complaint= useSelector((state) => state.searchComplaint.searchingComplaint);
    const handleSearch = async () => {
       await  dispatch(searchComplaint({ number, password }));
        setCurrentPage('status');
        navigate('/statusCheck'); 
    };
    const handleChangeComplaintType = (event) => {
    const newComplaintType = event.target.value;
    dispatch(changeComplaintType(newComplaintType));
    };


    // const handleNumber = (e) => {
    //     dispatch(setNumber(e.target.value));
    // };
    // const handlePassword = (e) => {
    //     dispatch(setPassword(e.target.value));
    // };
    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log("number: ", selector.number);
        // console.log("password: ", selector.password);
    };
  
  return (
  
        <div className="check-status-container-page">
            <Header/>
            <div className='check-status-searcher-container'>
                <div className="check-status-title-container">
                        <img style={{ marginLeft: "0px" }} src={red_line} />
                        <h3 className='check-status-title-text'>Wyszukaj zgłoszenie</h3>
                </div>
                <div className="search-complaint-container">
                    <p className='search-complaint-text-field-title'><b>Numer zgłoszenia</b></p>
                    <input type="text" className="search-complaint-text-field" style={{width: "335px"}}  value={number} onChange={(e) => setNumber(e.target.value)} />
                    <p className='search-complaint-text-field-title'><b>Hasło</b></p>
                    <input type="text" className="search-complaint-text-field" style={{width: "335px"}}  value={password} onChange={(e) => setPassword(e.target.value)} />
                    <br/>
                    <br/>
                    <button className="search-complaint-btn" style={{border:'none', cursor:'pointer'}} onClick={handleSearch}><p className='search-complaint-btn-text'>Szukaj</p></button>
                </div>
            </div>
        </div>
  
  )
}
export default StatusCheck;